/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, put, call } from 'redux-saga/effects';
import {
  LOGIN_REQUEST,
  RESTORE_PASSWORD_REQUEST,
  SEND_CODE_REQUEST,
  SIGN_UP_REQUEST,
  SignUpFormProps,
} from './types';
import { loginAction, restorePasswordAction, sendCodeAction, signUpAction } from './actions';
import { Auth } from '../../services/Auth';
import { SagaIterator } from 'redux-saga';
import { ActionType } from 'deox';
import { AxiosResponse } from 'axios';
import { getUserAction } from '../user/actions';
import { setAppStateAction } from '../app/actions';
import { processRequestError } from '../error/actions';

function* handleLogin(action: ActionType<typeof loginAction.request>): SagaIterator {
  try {
    const response: AxiosResponse = yield call(Auth.signIn, action.payload);
    yield put(loginAction.success());

    const userData = {
      firstName: response.data.first_name,
      lastName: response.data.last_name,
      phone: response.data.phone_number,
      email: response.data.email,
      isActive: response.data.is_active,
      pk: response.data.pk,
    };

    yield put(getUserAction.success({ data: userData, loading: false }));
    yield put(setAppStateAction({ loading: false, logged: true }));
    // yield put(setAppStateAction({ loading: false }));
  } catch (error: any) {
    yield put(processRequestError({ error, failAction: loginAction.failure }));
  }
}

function* handleSignUp(action: ActionType<typeof signUpAction.request>): SagaIterator {
  try {
    const signUpData: SignUpFormProps = action.payload;
    yield call(Auth.signUp, { data: signUpData });
    yield put(signUpAction.success());
    yield put(setAppStateAction({ loading: false, logged: true }));
    yield put(getUserAction.request());
    // yield put(setAppStateAction({ loading: false }));
  } catch (error: any) {
    yield put(processRequestError({ error, failAction: signUpAction.failure }));
  }
}

function* handleSendCode(action: ActionType<typeof sendCodeAction.request>): SagaIterator {
  try {
    const { phoneNumber } = action.payload;
    const response = yield call(Auth.sendCode, phoneNumber);
    yield put(sendCodeAction.success(response));
  } catch (error: any) {
    yield put(processRequestError({ error, failAction: sendCodeAction.failure }));
  }
}

function* handleRestorePassword(
  action: ActionType<typeof restorePasswordAction.request>,
): SagaIterator {
  try {
    yield call(Auth.resetPassword, action.payload);
    yield put(restorePasswordAction.success());
  } catch (error: any) {
    yield put(processRequestError({ error, failAction: restorePasswordAction.failure }));
  }
}

function* authSaga(): SagaIterator {
  yield takeLatest(LOGIN_REQUEST, handleLogin);
  yield takeLatest(SIGN_UP_REQUEST, handleSignUp);
  yield takeLatest(SEND_CODE_REQUEST, handleSendCode);
  yield takeLatest(RESTORE_PASSWORD_REQUEST, handleRestorePassword);
}

export default authSaga;
